import type { AddressAutocompleteItem } from '../../../core/models/address-autocomplete';

/**
 * Removes duplicate Canada Post suggestions by Id while preserving CP return order.
 */
export function dedupeAddressAutocompleteItems(
  items: readonly AddressAutocompleteItem[],
): AddressAutocompleteItem[] {
  const seenIds = new Set<string>();
  const deduped: AddressAutocompleteItem[] = [];

  for (const item of items) {
    if (seenIds.has(item.id)) {
      continue;
    }

    seenIds.add(item.id);
    deduped.push(item);
  }

  return deduped;
}
